import StatusIllustration from "@/assets/illustrations/status-illustration";
import { Text, View } from "react-native";
import { useSlot, useStyled } from "use-styled";

const StatusRoot = useStyled(View, {
  base: {
    className: "flex-1 items-center text-center",
  },
});

const StatusTitle = useStyled(Text, {
  base: {
    className:
      "text-teachLoop-accentPrimary font-geologica-medium text-xl leading-[1.5]",
  },
  variants: {},
  defaultVariants: {},
});

const StatusSubTitle = useStyled(Text, {
  base: {
    className:
      "text-center text-teachLoop-textPrimary font-geologica-regular text-base leading-[1.5]",
  },
  variants: {},
  defaultVariants: {},
});

const StatusIllustrator = useStyled(StatusIllustration, {
  base: {
    className: "w-[234] h-[227px]",
  },
  variants: {},
  defaultVariants: {},
});

export const Status = useSlot(StatusRoot, {
  Title: StatusTitle,
  SubTitle: StatusSubTitle,
  Illustrator: StatusIllustrator,
});
